import { format } from 'date-fns';

const getDay = (day: number) => {
	const now = new Date();
	return format(new Date(now.getFullYear(), 0, day), 'do');
};

export default getDay;
